/** @format */

/**
 * Utility to check if code is running in a browser environment
 * Use this instead of direct `typeof window !== "undefined"` checks
 */
export const isBrowser = (): boolean => {
  return typeof window !== "undefined" && typeof document !== "undefined";
};

/**
 * Safely access window object, returns undefined in SSR
 */
export const getWindow = (): Window | undefined => {
  return typeof window !== "undefined" ? window : undefined;
};

/**
 * Safely access document object, returns undefined in SSR
 */
export const getDocument = (): Document | undefined => {
  return typeof document !== "undefined" ? document : undefined;
};

/**
 * Safely access navigator object, returns undefined in SSR
 */
export const getNavigator = (): Navigator | undefined => {
  return typeof navigator !== "undefined" ? navigator : undefined;
};
